<template>
  <section>
    <transition name="fade-in" mode="out-in">
      <div tabindex="-1" v-show="visible" class="single-event-dialog" :id="'dialog-' + event.eventGuid" :style="{'margin-left': calcPosition() + 'px'}">
        <p class="label">
          {{ dateFormat(event.startDateTime) }} at {{ utcTimeFormat(event.startDateTime) }}
        </p>
        <img src="@/assets/images/payments/actions_ico.png" alt="actions" class="actions-ico" @click="toggleActions()" v-if="event.changeable" />
        <div class="action-menu" :class="[ actions ? 'select-menu-collapsed' : 'select-menu-not-collapsed' ]">
          <router-link v-if="event.eventGuid !== ''" :to="{ name: 'AddEvent', params: { id: event.eventGuid } }">
            <div class="item">{{ $lang.messages.edit }}</div>
          </router-link>
          <button class="item btn-item btn-delete" @click="deleteEvent">
            {{ $lang.messages.deleteTable }}
          </button>
        </div>
      
        <p class="label title">
          {{ event.eventTitle }}
        </p>
      
        <p class="label">
          {{ event.childSummary }}
        </p>
      
        <p class="label description">
          {{ event.description }}
        </p>
        
        <template v-if="event.attachmentResponseDtos !== null && event.attachmentResponseDtos.length !== 0">
          <f-p-input-download
            :inputDownloadText="$lang.messages.download"
            :attachmentResponse="event.attachmentResponseDtos"
            :isRecExpenseDetails="false"
          >
            <p class="label">
              {{ $lang.messages.attachments }}
            </p>
          </f-p-input-download>
        </template>
        
      </div>
    </transition>
    <!-- Delete Modal -->
    <delete-modal
      ref="deleteEventCalendar"
      @deleteEvent="deleteEventModal"
    >
    </delete-modal>
  </section>
</template>

<script>
  import { dateFormat } from "@/mixins/dateFormat";
  import DeleteModal from '@/components/common/modals/DeleteModal';
  import FPInputDownload from '@/components/common/inputs/FPInputDownload';
  import { utcTimeFormat } from '@/mixins/timeFormat';
  
  export default {
    name: "singleEventDialog",
    components: {
      'delete-modal': DeleteModal,
      'f-p-input-download': FPInputDownload
    },
    mixins: [
      dateFormat,
      utcTimeFormat
    ],
    props: {
      event: {
        type: Object,
        required: true,
        default: () => {}
      }
    },
    data() {
      return {
        actions: false,
        visible: false
      }
    },
    methods: {
      toggleActions() {
        this.actions = !this.actions;
      },
      deleteEvent() {
        this.$refs.deleteEventCalendar.show(this.event.eventGuid, 'card', 'deleteEvent')
      },
      deleteEventModal() {
        this.$emit('deleteEventModal', this.event.eventGuid)
      },
      calcPosition() {
        let event = document.getElementById(this.event.randomEventGuid)
  
        if (event) {
          this.visible = true
          if (event.getBoundingClientRect().right + 340 >= screen.width) {
            return -310;
          } else {
            return event.offsetWidth + 40
          }
    
        }
      }
    }
  }
</script>
